import { render, staticRenderFns } from "./FieldsPlaceholder.vue?vue&type=template&id=869bc93e&scoped=true&"
var script = {}
import style0 from "./FieldsPlaceholder.vue?vue&type=style&index=0&id=869bc93e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869bc93e",
  null
  
)

export default component.exports